import React from 'react';

interface VisCache {
  dashboardGadgets: Map<string, DashboardGadget>;
  reportGadgets: Map<string, ReportGadgets.ReportGadget>;
}

const EMPTY_VIS_CACHE: VisCache = {
  dashboardGadgets: new Map(),
  reportGadgets: new Map(),
};

interface VisualisationCacheContextType {
  cache: VisCache;
  requestDashboardGadgetsByIds: (ids: string[]) => void;
  requestAllDashboardGadgets: () => void;
  allGadgetsLoaded: boolean;
  isGadgetIdResolved: (id: string) => boolean;
  isGadgetIdNotFound: (id: string) => boolean;
  // A dashboard or report gadget whose fetch failed (it may exist)
  isGadgetIdFailed: (id: string) => boolean;
  requestReportGadgetsByIds: (ids: string[]) => void;
  requestAllReportGadgets: () => void;
  allReportGadgetsLoaded: boolean;
  isReportGadgetIdResolved: (id: string) => boolean;
  putReportGadgetInCache: (gadget: ReportGadgets.ReportGadget) => void;
}

const VisualisationCacheContext =
  React.createContext<VisualisationCacheContextType>({
    cache: EMPTY_VIS_CACHE,
    requestDashboardGadgetsByIds: () => undefined,
    requestAllDashboardGadgets: () => undefined,
    allGadgetsLoaded: false,
    isGadgetIdResolved: () => false,
    isGadgetIdNotFound: () => false,
    isGadgetIdFailed: () => false,
    requestReportGadgetsByIds: () => undefined,
    requestAllReportGadgets: () => undefined,
    allReportGadgetsLoaded: false,
    isReportGadgetIdResolved: () => false,
    putReportGadgetInCache: () => undefined,
  });

export type { VisCache };
export { EMPTY_VIS_CACHE };
export default VisualisationCacheContext;
